import React from 'react'
import { styled } from '@mui/material/styles'
import { Typography } from '@mui/material'
import { config } from '@/config'
import { AppButton } from '../ui'
import Grid from '@mui/material/Grid2'
import { Utils } from '@/lib/utils'

interface Props {
  onClose: () => void
}

const ResultBlock = styled(Grid)`
  width: 330px;
  height: 100%;

  ${({ theme }) => theme.breakpoints.only('xs')} {
    width: 100%;
  }
`

const ResultBlockText = styled(Grid)`
  flex: 1;
`

const Title = styled(Typography)`
  color: ${({ theme }) => theme.custom.colors.common.black};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`

const TypographyWithLineHeight = styled(Typography)`
  line-height: 21px;
`

const TypographyNoMessage = styled(TypographyWithLineHeight)`
  color: ${({ theme }) => theme.custom.colors.common.red};
  font-weight: 600;
`

const SupportLink = styled('a')`
  text-decoration: underline;
  color: ${({ theme }) => theme.custom.colors.common.green};
`

const ResultBlockButton = styled(Grid)`
  flex: 1;
  display: flex;
  align-items: flex-end;
`

export const SendingLinkResultBlock: React.FC<Props> = ({ onClose }) => {
  const formattedPhone = Utils.formatPhoneToDashed(config.customerSupport.phone)

  return (
    <ResultBlock container direction="column">
      <ResultBlockText>
        <Title variant="h2">Check your TEXT messages.</Title>
        <Grid container direction="column" alignItems="stretch" spacing={2}>
          <Grid>
            <Typography variant="body1">Click on the link we sent to verify it's really you.</Typography>
          </Grid>
          <Grid>
            <TypographyNoMessage variant="body1">Didn't receive a TEXT message?</TypographyNoMessage>
            <Typography variant="body1">Click return and re-enter your mobile number.</Typography>
          </Grid>
          <Grid>
            <Typography variant="body1">Need help?</Typography>
            <Typography variant="body1">
              Customer Support{' '}
              <SupportLink href={`tel:${config.customerSupport.phone}`}>+1 {formattedPhone}</SupportLink>
              <br />
              <SupportLink target="_blank" href={`mailto:${config.customerSupport.email}`}>
                {config.customerSupport.email}
              </SupportLink>
            </Typography>
          </Grid>
        </Grid>
      </ResultBlockText>
      <ResultBlockButton>
        <AppButton fullWidth variant="outlined" onClick={onClose}>
          Return
        </AppButton>
      </ResultBlockButton>
    </ResultBlock>
  )
}
